const Heading = ({heading}) => {
    return (
        <div className="col">
            <h1>{heading}</h1>
        </div>
    )
}

export default Heading
